import React from "react";
import { FormGroup } from "reactstrap";
import "./index.scss";
import { Select } from "shared";

interface CustomDropdownInputProps {
  data: any;
  options: Array<any>;
  labels?: any;
  labelText?: string;
  callback: Function;
  attributeName: string;
  disabled?: boolean;
  note?: string;
  placeholder?: string;
  style?: object;
  customValue?: any;
  formFeedbackText?: string;
  invalid?: boolean;
}

export default function CustomDropdownInput({
  data,
  options,
  labels,
  labelText,
  callback,
  attributeName,
  disabled = false,
  note,
  placeholder = "",
  style,
  customValue = null,
  formFeedbackText,
  invalid,
}: CustomDropdownInputProps) {
  let value = null;

  if (options.length === 0) {
    value = {
      label: data[attributeName]?.name,
      value: data[attributeName]?.id,
    };
  } else {
    const valueCompare =
      customValue || data[attributeName]?.id || data[attributeName];
    value = options.find((item) => item.value == valueCompare);
  }
  const values = value ? [value] : [];
  return (
    <div className="custom-attribute__text-input" style={style}>
      {labels && !!labels[attributeName] && (
        <span className="custom-attribute__text-input-label">
          {labels[attributeName]}
        </span>
      )}
      {labelText && (
        <span className="custom-attribute__text-input-label">{labelText}</span>
      )}
      <FormGroup>
        <Select
          editable
          readOnly={disabled}
          data={options}
          label={placeholder}
          values={values}
          onChanged={(selectedOptions) =>
            callback(attributeName, selectedOptions?.[0] || {})
          }
          invalid={invalid}
        />
        {invalid && formFeedbackText && (
          <span className="custom-attribute__text-input-invalid">
            {formFeedbackText}
          </span>
        )}
      </FormGroup>
      {note && <p className="custom-attribute__text-input-note">{note}</p>}
    </div>
  );
}
